import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import './auction-terms.css';

const AuctionTermsPage = () => {
  const { find, meta } = usePageContent('auction-terms');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Auction terms');
  useMeta(seo);
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header auction-terms-header">
        <div className="content-holder content-holder--indented">
          <h1 className="page-header__title">{c.pageTitle || 'Auction terms'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented auction-terms-body">
        <div className="rich-text auction-terms-rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default AuctionTermsPage;
